/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-23, 14:43:44
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  authType: 'initial',
  isAuthenticated: false,
  loginCredentialsIncorrect: false,
  loginErrorReason: null,
  loginLoadingActive: false,
  subscriber: {
    number: null,
    code: null,
    type: null,
    id: null,
    account_balance: null,
    individual_account_number: null,
  },
  settings: {
    complainsCategories: null,
  },
  acl: {
    isMainNumber: true,
    privileges: {},
  },
};

const getters = {
  authType: state => state.authType,
  isAuthenticated: state => state.isAuthenticated,
  loginCredentialsIncorrect: state => state.loginCredentialsIncorrect,
  loginLoadingActive: state => state.loginLoadingActive,
  loginErrorReason: state => state.loginErrorReason,
  subscriber: state => state.subscriber,
  settings: state => state.settings,
  acl: state => state.acl,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/Subscriber/index.js